function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var _ref2 = /*#__PURE__*/React.createElement("g", {
  transform: "translate(0.000000,512.000000) scale(0.100000,-0.100000)",
  fill: "#000000",
  stroke: "none"
}, /*#__PURE__*/React.createElement("path", {
  d: "M396 5000 c-16 -5 -44 -24 -63 -42 -59 -57 -63 -89 -63 -485 l0 -353 785 0 785 0 0 445 0 445 -707 -1 c-390 0 -721 -5 -737 -9z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M2180 4565 l0 -445 365 0 365 0 0 445 0 445 -365 0 -365 0 0 -445z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M3260 4565 l0 -445 790 0 790 0 0 348 c0 392 -3 412 -69 480 -26 26 -53 43 -84 50 -32 9 -247 12 -736 12 l-691 0 0 -445z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M270 2966 l0 -814 34 -6 c64 -12 174 -75 233 -134 32 -32 175 -185 318 -341 l260 -283 7 99 c10 131 37 216 92 291 76 102 181 169 302 191 35 7 227 11 489 11 373 0 438 2 481 16 27 9 135 57 241 105 300 138 443 174 688 173 244 -2 407 -45 678 -181 82 -41 150 -73 151 -71 1 2 17 35 36 73 63 131 195 234 338 264 29 6 91 11 137 11 l85 0 0 705 0 705 -789 0 -790 0 -3 -332 c-3 -377 -5 -386 -81 -436 l-41 -27 -563 -3 c-374 -2 -577 1 -603 8 -49 13 -99 54 -116 97 -11 25 -14 106 -14 363 l0 330 -785 0 -785 0 0 -814z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M2180 3550 l0 -230 365 0 365 0 0 230 0 230 -365 0 -365 0 0 -230z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M4651 2013 c-18 -9 -45 -34 -60 -57 l-26 -40 0 -821 0 -821 28 -43 c44 -66 71 -73 263 -69 186 3 201 9 242 88 l22 44 0 801 0 801 -22 44 c-41 79 -56 85 -246 88 -140 2 -172 0 -201 -15z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M3285 1930 c-117 -15 -235 -55 -448 -154 -306 -141 -234 -129 -797 -136 -455 -5 -487 -6 -513 -24 -50 -34 -57 -61 -57 -220 l0 -145 783 -3 c746 -3 784 -4 820 -22 118 -58 123 -227 9 -298 l-37 -23 -860 0 c-852 0 -861 1 -937 22 -42 12 -111 39 -153 60 -130 64 -140 73 -629 602 -206 222 -234 242 -319 222 -63 -14 -102 -43 -127 -91 -24 -48 -25 -94 -2 -137 33 -62 835 -1024 919 -1102 190 -178 426 -296 694 -348 84 -16 156 -18 709 -18 866 1 912 6 1748 205 l132 32 0 646 0 647 -198 102 c-206 105 -302 145 -412 168 -89 19 -240 25 -325 15z"
}));
function SvgProposal(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "512.000000pt",
    height: "512.000000pt",
    viewBox: "0 0 512.000000 512.000000",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProposal);
export default __webpack_public_path__ + "static/media/proposal.b5fb8745caab3f506377af566b82664b.svg";
export { ForwardRef as ReactComponent };